export default __webpack_public_path__ + "static/media/infoIconGrey.597633f5.svg";